import * as React from 'react';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { ItemCardList } from 'components/ItemList/ItemCardList';
import { IItemCardList } from 'models/itemcard';
import { Button } from 'components/Common/Button';
import { getProductCard } from 'redux/modules/product/productcard';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { removeShoppingBasketItem, setWizardStep, getShoppingBasket } from 'redux/modules/cart';
import { browserHistory } from 'react-router';
import { IShoppingBasketItem } from 'models/cart/shoppingbasketitem';
import { ShoppingBagRemovedItems } from 'components/Cart/ShoppingBagRemovedItems';
import { formatCurrency, formatInteger } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
import { dropdown, IDropdownProps, closeAllDropdowns } from 'helpers/hooks';
import { IStore } from 'redux/IStore';
import { Dispatch } from 'react-redux';
import { ITranslateProps } from 'models/common';

interface IProps
	extends IDropdownProps,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {
	show?: boolean;
	stateChanged: (open: boolean) => void;
}

interface IShoppingBagDropdownItemCardList extends IItemCardList {
	currencyKey?: number;
}

const mapStateToProps = (state: IStore) => ({
	cart: state.cart,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	getShopCard: (id: string, target?: string) => dispatch(getShopCard(id, target)),
	getProductCard: (id: string, target?: string) => dispatch(getProductCard(id, target)),
	removeShoppingBasketItem: (itemId: string) => dispatch(removeShoppingBasketItem(itemId)),
	setWizardStep: (wizardStep: number) => dispatch(setWizardStep(wizardStep)),
	getShoppingBasket: () => dispatch(getShoppingBasket()),
});

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
@dropdown()
class ShoppingBagDropdownComponent extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.handleViewBagButtonClick = this.handleViewBagButtonClick.bind(this);
		this.handleCheckoutButtonClick = this.handleCheckoutButtonClick.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	public componentDidMount() {
		this.props.getShoppingBasket();
	}

	public componentDidUpdate(prevProps: IProps) {
		const { cart } = this.props;

		if (
			!prevProps.cart.showShoppingBagDropdown &&
			cart.showShoppingBagDropdown &&
			(!cart.shoppingBasket ||
				!cart.shoppingBasket.items ||
				(cart.shoppingBasket.items && cart.shoppingBasket.items.length === 0))
		) {
			this.props.getShoppingBasket();
			this.props.toggle(true);
		}

		if (this.props.open !== prevProps.open && this.props.open !== this.props.show) {
			this.props.stateChanged(this.props.open);
		}
	}

	private goToCard(id: string, type: string, target: string) {
		closeAllDropdowns();
		switch (type) {
			case c.NODE_TYPE_SHOP:
				this.props.getShopCard(id, target);
				break;

			case c.NODE_TYPE_PRODUCT:
				this.props.getProductCard(id, target);
				break;

			default:
				break;
		}
	}

	private handleViewBagButtonClick() {
		closeAllDropdowns();
		this.props.setWizardStep(c.CART_STEP_SHOPPING_BAG);
		browserHistory.push('/cart');
	}

	private handleCheckoutButtonClick() {
		closeAllDropdowns();
		this.props.setWizardStep(c.CART_STEP_CHECKOUT_ADDRESS);
		browserHistory.push('/cart');
	}

	public render() {
		const { t, open, toggle } = this.props;
		const { isFetching, shoppingBasket } = this.props.cart;

		let content: JSX.Element = null;
		let removedItems: IShoppingBasketItem[] = [];
		if (isFetching) {
			content = null;
		} else if (shoppingBasket && shoppingBasket.items && shoppingBasket.items.length > 0) {
			removedItems = shoppingBasket.items.filter((x) => x.shopId === null);
			const listProps: IShoppingBagDropdownItemCardList = {
				items: shoppingBasket.items.filter((x) => x.shopId !== null),
				itemType: c.NODE_TYPE_CHECKOUTPRODUCT_ITEM_CARD,
				currencyKey: shoppingBasket.currencyKey,
				goToCard: this.goToCard,
				deleteItem: (id) => {
					this.props.removeShoppingBasketItem(id);
				},
			};
			content = (
				<>
					<div>
						<ShoppingBagRemovedItems
							items={removedItems}
							removeShoppingBasketItem={(id: string) => {
								this.props.removeShoppingBasketItem(id);
							}}
						/>
					</div>
					<div>
						<ItemCardList {...listProps} />
					</div>
					<footer>
						<div>
							{t('BSPortal_Common_Total')}
							<strong>{formatCurrency(shoppingBasket.currencyKey, shoppingBasket.itemsTotal)}</strong>
						</div>
						<Button type="button" onClick={this.handleViewBagButtonClick}>
							{t('Cart_ShoppingBagDropdown_Button_ViewBag')}
						</Button>
					</footer>
				</>
			);
		} else {
			content = (
				<>
					<div className="mainMessage">{t('Cart_ShoppingBagDropdown_Label_NothingInYourBag')}</div>
				</>
			);
		}

		return (
			<div className="dropdownHolder cartDropdownHolder" ref={this.props.ref1}>
				<a className="iconBtn" title={t('Cart_ShoppingBag_Label_ShoppingBag')} onClick={toggle}>
					{renderIcon('bag')}
				</a>
				<div
					ref={this.props.ref1}
					className="dropdown shoppingBagDropdown right"
					style={{ display: open === true ? 'block' : 'none' }}
				>
					<div className="dropdownHeader">
						<h4>
							{t('Cart_ShoppingBagDropdown_Label_MyBag')}
							{shoppingBasket?.items?.length ? (
								<span className="muted">
									&nbsp;
									{t('Cart_ShoppingBagDropdown_Label_ItemsCount', {
										count: formatInteger(shoppingBasket.items.length),
									})}
								</span>
							) : null}
						</h4>
						<a className="btnIcon muted" href="#" onClick={this.props.toggle}>
							{renderIcon('exit')}
						</a>
					</div>
					{content}
				</div>
			</div>
		);
	}
}

const ShoppingBagDropdown = connect(mapStateToProps, mapDispatchToProps)(ShoppingBagDropdownComponent);

export { ShoppingBagDropdown };
